import React from "react";
import Button from "storybookComponents/Button";
import Chips from "storybookComponents/Chips";
import Expansion from "components/Expansion";
import { isEmail } from "../utils";
import RightContent from "../components/rightSection";

const Approvers = ({ classes, approversData, onSave, event }) => {
  const [expanded, setExpanded] = React.useState(false);
  const [approvers, setApprovers] = React.useState([]);
  const [validate, setValidate] = React.useState(true);

  const handleExpandedPanel = () => setExpanded(!expanded);

  const handleApprovers = (data) => setApprovers(data);

  const handleSave = () => onSave({ approverEmails: approvers });

  const validation = () => {
    for (const item of approvers) {
      if (!isEmail(item)) return false;
    }
    return true;
  };

  const renderRightContent = (open) => {
    if (open) return null;
    return <RightContent classes={classes} list={approvers} />;
  };

  const renderHeaderIcon = (open) => {
    if (open) return null;
    return <div className={classes.numberWrapper}>{approvers.length}</div>;
  };

  const renderContent = () => (
    <div className={classes.collapseContentWrapper}>
      <div className={classes.text1}>
        Please add all the contacts who are authorized to approve {event ? "events" : "e-blasts"}
      </div>

      <Chips
        propValues={approvers}
        label="Email(s)"
        onChangeCallback={handleApprovers}
        helperText="Press ‘Enter’ or ‘Comma’ to add multiple emails"
        placeholder=""
        className={classes.chipsWrapper}
        validator={isEmail}
      />

      <div className={classes.text2}>
        Any one of these approvers will need to approve {event ? "events" : "e-blasts"} in order to
        be sent at the scheduled date and time. Also can disapprove in case of any changes required.
      </div>

      <div className={classes.btnWrapper}>
        <Button
          className={classes.btn}
          state={validate && approvers.join() !== approversData.join() ? "" : "inactive"}
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </div>
  );

  React.useEffect(() => {
    if (approversData) setApprovers(approversData);
  }, [approversData]);

  React.useEffect(() => {
    setValidate(validation());
  }, [approvers]);

  return (
    <Expansion
      handleExpandedPanel={handleExpandedPanel}
      expanded={expanded}
      header="Approvers"
      headerIcon={renderHeaderIcon}
      rightSection={renderRightContent}
    >
      {renderContent()}
    </Expansion>
  );
};

export default Approvers;
